import { render, staticRenderFns } from "./WaiverSignForm.vue?vue&type=template&id=af5071d2&"
import script from "./WaiverSignForm.vue?vue&type=script&lang=js&"
export * from "./WaiverSignForm.vue?vue&type=script&lang=js&"
import style0 from "./WaiverSignForm.vue?vue&type=style&index=0&id=af5071d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports